//
// Copyright (c) 2024 Comcast
//

import PropTypes from 'prop-types'
import DynamicTextArea from 'components/Shared/DynamicTextArea/Index'
import { useTranslation } from 'react-i18next'
import { Field } from 'react-final-form'
import { customIsEqual } from './utils'

const FieldComponent = ({
  isReadOnly,
  value,
  onChange,
  placeholder,
  minRowsTextArea,
  disabled,
  isError,
}) => {
  const { t } = useTranslation()

  if (isReadOnly) {
    return value
  }

  return (
    <DynamicTextArea
      small
      value={value}
      placeholder={(placeholder !== undefined) ? placeholder : t('common.typeHere')}
      onChange={onChange}
      minRows={minRowsTextArea}
      disabled={disabled}
      isError={isError}
    />
  )
}

FieldComponent.propTypes = {
  isReadOnly: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  minRowsTextArea: PropTypes.number,
  disabled: PropTypes.bool,
  isError: PropTypes.bool,
}

const TextAreaField = ({ name, placeholder, validate, minRowsTextArea, disabled, isReadOnly }) => {
  return (
    // without custom parse empty values are not passed to onSubmit() so API doesn't get cleared strings
    // see https://github.com/final-form/react-final-form/issues/130#issuecomment-425482365
    <Field
      name={name}
      isEqual={customIsEqual}
      validate={validate}
      parse={value => (value)}
    >
      {({ input, meta }) => {
        return (
          <FieldComponent
            isReadOnly={isReadOnly}
            value={input.value}
            onChange={input.onChange}
            placeholder={placeholder}
            minRowsTextArea={minRowsTextArea}
            disabled={disabled}
            isError={!!meta.error?.highlight}
          />
        )
      }}
    </Field>
  )
}

TextAreaField.propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.string,
  validate: PropTypes.func,
  minRowsTextArea: PropTypes.number,
  disabled: PropTypes.bool,
  isReadOnly: PropTypes.bool,
}

export default TextAreaField
